module.exports = __webpack_public_path__ + "assets/img/yzzx_m_anru.2f76aa02.png";